import { defineStore } from "pinia";
import axios, { ResponseType } from "@/utils/request";

export interface CityListItem {
  id: number;
  displayName: string;
  code: string;
}

export interface CityState {
  cityList: CityInfo; // 全部城市列表
  cityValue: string; // 城市关键字搜索
  needReflash: boolean; // 查询条件 + 页码重制， 页面刷新
  reflashNum: number; // 点击菜单刷新开关
  tablePageReflash: boolean; // 查询条件不重置 +  页码重制， 页面刷新
}
interface CityInfo {
  departureCityList: CityListItem[];
  arrivalCityList: CityListItem[];
}

export const useCityStore = defineStore({
  id: "cityList",
  state: (): CityState => ({
    cityList: {
      departureCityList: [],
      arrivalCityList: [],
    },
    cityValue: "",
    needReflash: true,
    reflashNum: 0,
    tablePageReflash: false,
  }),
  getters: {
    // cityOption(state): CityState["cityList"] {
    //   const newValue = state.cityValue.toLowerCase().trim();
    //   if (!newValue) {
    //     return state.cityList; // 重制回allList
    //   } else {
    //     return state.cityList.filter(
    //       (item) =>
    //         item.nameCn.includes(newValue) ||
    //         item.nameHk.includes(newValue) ||
    //         item.nameEn.toLowerCase().includes(newValue)
    //     );
    //   }
    // }, // 目前用不到
  },
  actions: {
    async getCityList(): Promise<void> {
      const res: ResponseType = await axios.get(
        "/facade/sale/agency/base/cities"
      );
      if (res.code === 0) {
        this.updateAllCityList(res.data);
      }
    },
    updateAllCityList(list: CityInfo): void {
      this.cityList = list;
    },
    updateCityValue(value: string): void {
      this.cityValue = value;
    },
    updateNeedReflash(value: boolean): void {
      this.needReflash = value;
    },
    updateReflashNum(): void {
      this.reflashNum++;
    },
    updateTablePageReflash(value: boolean): void {
      this.tablePageReflash = value;
    },
  },
});
